export default __webpack_public_path__ + "static/media/architecture-img-15.74ea3ee7.png";